import useGetOpenOrders from '@hooks/useGetOpenOrders'
import React, { useState } from 'react'
import { useLocation, Redirect } from 'react-router-dom'
import { OrderListContainer, SpinnerContainer } from './OrderList.style'
import { CARPAY_STATUS } from 'parkdepot-shared/models/database'
import CarpayOrderCard from '@components/CarpayOrderCard/CarpayOrderCard.component'
import { getFragmentData } from 'parkdepot-shared/gql'
import { OrderResponseFragment } from '@graphql/queries/getOpenOrders.query'
import Spinner from 'parkdepot-shared/components/Spinner'
import Error from '@components/Error/Error.component'
import carpayLPNotFoundRoute from '../NotFound/route.const'
import OpenOrder from '../OpenOrder/OpenOrder.view'

const CarpayOrderList = () => {
    const { search } = useLocation()
    const queryparams = new URLSearchParams(search)
    const plate = queryparams.get('plate')
    const orderId = queryparams.get('order_id')

    const [selectedOrderId, setSelectedOrderId] = useState<string | null>(orderId || null)

    const { data, loading, error } = useGetOpenOrders({
        variables: {
            plates: [plate!] // should exist because of skip
        },
        skip: !plate,
        fetchPolicy: 'network-only',
        pollInterval: 30000
    })

    if (loading && !data) {
        return (
            <SpinnerContainer>
                <Spinner theme="primary" size="xl" />
            </SpinnerContainer>
        )
    }

    if (error || !plate) {
        return <Error />
    }

    if (!data?.b2c_get_open_orders.orders.length) {
        // Probably redirect to Home or error flow
        return <Redirect to={`${carpayLPNotFoundRoute}?${queryparams.toString()}`} />
    }

    const orders = data!.b2c_get_open_orders.orders.map((data) => getFragmentData(OrderResponseFragment, data))

    const selectedOrder =
        orders.length === 1 ? orders[0] : orders.find((order) => order.order.order_id === selectedOrderId)

    if (selectedOrder) {
        return <OpenOrder orders={orders} selectedOrder={selectedOrder} setSelectedOrderId={setSelectedOrderId} />
    }

    const sortedOrders = orders.sort((resp) => (resp.order.status === CARPAY_STATUS.INCOMPLETE ? 1 : -1))

    return (
        <OrderListContainer>
            <div>
                {sortedOrders.map((order, i) => (
                    <CarpayOrderCard
                        key={order.order.order_id}
                        data={order}
                        isLast={i === sortedOrders.length - 1}
                        onClick={() => setSelectedOrderId(order.order.order_id)}
                    />
                ))}
            </div>
        </OrderListContainer>
    )
}

export default CarpayOrderList
